import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_481: DocMigration = {
  maxSchemaVersion: "0.0.481",
  description: "Add viewScale to drawing templates",
  apply(json: any) {
    const { contentTemplates = {} } = json;
    const contentTemplateIds = Object.keys(contentTemplates);

    for (const contentTemplateId of contentTemplateIds) {
      const contentTemplate = contentTemplates[contentTemplateId];
      if (contentTemplate.templateType === "DRAWING") {
        contentTemplate.viewScale = 1;
      }
    }

    json.contentTemplates = contentTemplates;
    return json;
  },
};
export default migration_0_0_481;
